/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
import moment from "moment-business-days";
import { getNotasDePedidoCategory } from "../../services/notasDePedidoServices";

// export function configurarServicio(meta) {
//   let servicio;

//   switch (meta) {
//     case "SOURCER-RECRUITER":
//       servicio = 3;
//       break;
//     case "CONSULTANT":
//       servicio = 1;
//       break;
//     case "MIXED RECRUITER":
//       servicio = "3, 1";
//       break;
//     default:
//       servicio = null;
//       break;
//   }

//   return servicio;
// }

export function getMetaServicios(metaServicio) {
  if (!metaServicio) return null;

  // Diccionario de mapeo de servicios a números
  const mapeo = {
    PP: 1,
    PT: 3,
    PO: 5,
  };

  const siglasLista = metaServicio.split(",");
  const serviciosIds = siglasLista.map((sigla) => mapeo[sigla]).filter((id) => id !== undefined);

  // Convertir el array de números a un string
  return serviciosIds.join(", ");
}

export function getSiglaServicio(id, text) {
  if (id === undefined || id === null) return null;

  const mapeoInverso = {
    1: "PP",
    3: "PT",
    5: "PO",
  };

  return mapeoInverso[id] || text;
}

export function configurarServicioParaTabla(servicio) {
  switch (servicio) {
    // Personal Temporal
    case 3:
      return "PT";
    // Busqueda y seleccion
    case 1:
      return "PP";
    // Outsourcing Procesos
    case 5:
      return "PO";

    default:
      return "-";
  }
}
export function getColorByEstado(estado) {
  switch (estado) {
    case 1: // "Abierta"
      return "#01ADEA";
    case 2: // "Reclutando"
      return "#FAB600";
    case 3: // "Derivada"
      return "#A4338A";
    case 4: // "Parcialmente Cubierta"
      return "#01A291";
    case 8: // "Pre Ingreso"
      return "#4979FC";
    case 5: // "Cubierta"
      return "#2FA836";
    case 6: // "Anulada"
      return "#928782";
    case 9: // "Pre Cancelada"
      return "#ff5722";
    case 7: // "Cancelada"
      return "#EA580B";
    case 10: // "Preventiva"
      return "#CCCCCC";
    case 11: // "Entrevista Cliente"
      return "#cf0e3eb5";
    case 12: // "Base Preventiva"
      return "#CCCCCC";
    default:
      return "#FFF";
  }
}

export const getColorByEstadoCandidate = (estado) => {
  switch (estado) {
    case 1: // "Rec. Preventiva"
      return "#01ADEA";
    case 2: // "Reclutando"
      return "#FAB600";
    case 3: // "Derivada"
      return "#A4338A";
    case 4: // "Parcialmente Cubierta"
      return "#01A291";
    case 8: // "Pre Ingreso"
      return "#4979FC";
    case 5: // "Ingreso"
      return "#2FA836";
    case 6: // "No Avanza"
      return "#928782";
    case 7: // "Postulado"
      return "#f0292a";

    default:
      return "#FFF";
  }
};

export function addTransparency(color, transparency) {
  // El color debe estar en formato hex (#RRGGBB)
  if (color.startsWith("#")) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${transparency})`;
  }
  return color; // Si el color no está en formato hex, se devuelve tal cual
}

export const getTextByEstado = (estado, list) => {
  const obj = list ? list.find((objeto) => objeto.id === estado) : null;
  const estadoText = obj ? obj.text : "";
  return estadoText;
};

export function getSLAColor(health) {
  switch (health) {
    case 1:
      return "#22af47";
    case 2:
      return "#FAB600";
    case 3:
      return "#F02A2B";
    default:
      return "rgb(196 193 193)";
  }
}

const holidays = {}; // Variable global para almacenar los días festivos

export const initializeHolidays = async () => {
  const years = [new Date().getFullYear(), new Date().getFullYear() + 1];
  const requests = years.map(async (year) => {
    // los feriados vienen por categories desde un enum en el back
    const res = await getNotasDePedidoCategory();

    const calendars = res ? res.result.holidaysEnum[year] : [];

    for (const data of calendars) {
      const dia = `${data.dia}`.padStart(2, "0");
      const mes = `${data.mes}`.padStart(2, "0");
      holidays[`${year}-${mes}-${dia}`] = data.motivo;
    }
  });

  await Promise.all(requests);

  moment.locale("es");
  moment.updateLocale("us", {
    holidays: Object.keys(holidays),
    holidayFormat: "YYYY-MM-DD",
  });
};

// Llamar a la función de inicialización en algún lugar antes de utilizar los días festivos
// initializeHolidays();

// calcula la cantidad de dias habiles entre dos fechas
export const calcularDiasHabiles = (desdeFecha, fechaDeCierre) => {
  const startDate = moment(desdeFecha);
  let endDate;
  if (fechaDeCierre != null) {
    endDate = moment(fechaDeCierre);
  } else {
    endDate = moment();
  }

  let count = 0;
  const tempDate = startDate.clone();

  while (tempDate.isBefore(endDate)) {
    tempDate.add(1, "day");

    // Verificar si es un día hábil y no un día festivo
    if (tempDate.isBusinessDay()) {
      count++;
    }
  }

  return count;
};

// calcula a partir de una fecha y una cantidad de dias
// (positivo para adelante, negativo para atras),
// una nueva fecha teniendo en cuenta solo dias habiles
export const calcularFechaHabil = (fecha, dias) => {
  const startDate = moment(fecha);
  let count = 0;
  const tempDate = startDate.clone();

  while (count < Math.abs(dias)) {
    if (dias > 0) {
      tempDate.add(1, "day");
    } else {
      tempDate.subtract(1, "day");
    }

    if (tempDate.isBusinessDay()) {
      count++;
    }
  }

  return tempDate.format("YYYY-MM-DD");
};

export const getRegionTitleById = (id, regiones) => {
  const region = regiones.find((item) => item.itemId === id);
  return region ? region.title : null;
};

export const getSucursalTitleById = (id, sucursales) => {
  const sucursal = sucursales.find((objeto) => objeto.itemId === id);
  return sucursal ? sucursal.titulo : "-";
};

export const getStylesByOrigen = (origen) => {
  switch (origen) {
    case 1:
      return {
        backgroundColor: "#F0292A", // Rojo
        color: "white",
      };
    case 2:
      return {
        backgroundColor: "#CCCCCC", // Gris
        color: "black",
      };
    case 3:
      return {
        backgroundColor: "#fab600", // Amarillo
        color: "black",
      };
    default:
      return {
        backgroundColor: "#293134", // Gris oscuro
        color: "white",
      };
  }
};

export const calculatePercentage = (avisos, nps) => {
  if (nps === 0) return 0;
  return ((avisos / nps) * 100).toFixed();
};

export const getSourcerName = (sourcerId, pisList) => {
  const sourcer = pisList ? pisList.find((objeto) => objeto.itemId === sourcerId) : null;
  return sourcer ? sourcer.nombreApellido : "-";
};
